// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para el módulo financiero principal - Diseño exacto de la imagen */

.financial-module {
  background: white;
  padding: 0;
  margin-bottom: 2rem;
}

/* Contenedor de secciones */
.sections-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Tarjeta de sección financiera */
.financial-section-card {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.financial-section-card:hover {
  box-shadow: none;
}

/* Header de la sección - Naranja como en la imagen */
.section-header {
  background: #f09502;
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.drag-handle {
  cursor: grab;
  color: rgba(255, 255, 255, 0.8);
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.drag-handle:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.drag-handle:active {
  cursor: grabbing;
}

.section-title h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
}

/* Headers de columnas como cajas independientes */
.column-headers {
  display: flex;
  gap: 10px;
  padding: 0;
  background: transparent;
  border-bottom: none;
  margin-bottom: 15px;
}

.header-box {
  background: #F3F3F3 !important;
  color: #000 !important;
  height: 49px;
  border-radius: 10px !important;
  padding: 0 1rem;
  font-weight: 600;
  font-size: 0.8rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.header-box:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.section-title-box {
  flex: 7 1 0 !important; /* 70% of available space roughly */
  width: auto !important;
  justify-content: center;
}

.section-title-box h3 {
  color: #000 !important;
  text-align: center !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.objective-header-box {
  flex: 1 0 0 !important;
  width: auto !important;
  min-width: auto !important;
  color: #000 !important;
  text-align: center !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.add-button-box {
  width: 40px;
  padding: 0.25rem;
}

/* Responsive para mobile */
@media (max-width: 768px) {
  .column-headers {
    gap: 0.25rem;
    padding: 0.5rem;
  }
  
  .header-box {
    padding: 0.4rem 0.5rem;
    font-size: 0.7rem;
  }
  
  .section-title-box {
    min-width: 120px;
    gap: 0.25rem;
  }
  
  .percentage-header-box {
    width: 50px;
  }
  
  .objective-header-box {
    width: 70px;
  }
  
  .add-button-box {
    width: 35px;
    padding: 0.2rem;
  }
}

/* Botón de añadir */
.add-item-btn {
  background: #6c757d;
  color: white;
  border: 2px solid #6c757d;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}

.add-item-btn:hover {
  background: #f09502;
  border-color: #f09502;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.3);
}

/* Contenido de la sección */
.section-content {
  padding: 0;
}

/* Lista de campos */
.fields-list {
  display: flex;
  flex-direction: column;
}

/* Lista de subsecciones */
.subsections-list {
  display: flex;
  flex-direction: column;
}

/* Subsección individual */
.subsection {
  border-bottom: none;
}

/* Header de subsección como fila de cajas */
.subsection-header-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  padding: 0;
}

.subsection-header-box {
  background: #F3F3F3 !important;
  color: #000;
  border-radius: 10px !important;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 7 1 0 !important;
  width: auto !important;
  box-shadow: none;
  height: 49px;
}

.subsection-header-box h4 {
  color: #000 !important;
  text-align: center !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.empty-box {
  background: #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-weight: 600;
  font-size: 0.8rem;
}

/* Asegurar modelo de caja consistente */
.header-box, .field-box, .empty-box {
  box-sizing: border-box;
}

/* Anchos específicos uniformes */
.objective-header-box, 
.sub-header-currency, 
.value-box {
  flex: 3 1 0 !important; /* 30% of available space */
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  gap: 6px !important;
}

.add-button-box, 
.sub-header-action, 
.delete-box {
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
}

/* Ajuste específico para header de subsecciones */
.sub-header-currency,
.sub-header-action {
  height: 49px;
}

/* Campos de la subsección */
.subsection-fields {
  display: flex;
  flex-direction: column;
}

/* Contenedor de drag & drop */
.fields-list {
  display: flex;
  flex-direction: column;
}

.fields-list.cdk-drop-list-dragging .field-row:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

/* Fila de campo individual */
.field-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 10px;
  cursor: grab;
  padding: 0;
  transition: all 0.2s ease;
}

.field-row:active {
  cursor: grabbing;
}

.field-row.cdk-drag-preview {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transform: rotate(2deg);
}

.field-row.cdk-drag-placeholder {
  opacity: 0.4;
}

.field-row.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

/* Cajas independientes */
.field-box {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 12px 1rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.field-box:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.label-box, .subsection-header-box {
  flex: 7 1 0 !important;
  width: auto !important;
  justify-content: center;
}



.delete-box {
  width: 40px;
  padding: 0.25rem;
}

/* Caja de drag handle */
.drag-handle-box {
  width: 30px;
  justify-content: center;
  background: transparent;
  border: none;
  box-shadow: none;
}

.drag-handle {
  color: #6c757d;
  cursor: grab;
  font-size: 1rem;
  padding: 0.25rem;
}

.drag-handle:hover {
  color: #495057;
}

.drag-handle:active {
  cursor: grabbing;
}

/* Responsive para mobile */
@media (max-width: 768px) {
  .field-row {
    gap: 0.25rem;
    padding: 0 0.25rem;
  }
  
  .field-box {
    padding: 0.4rem 0.25rem;
  }
  
  .label-box {
    min-width: 120px;
    gap: 0.25rem;
  }
  
  .percentage-box {
    width: 50px;
  }
  
  .value-box {
    width: 70px;
  }
  
  .delete-box {
    width: 35px;
    padding: 0.2rem;
  }
  
  .drag-handle-box {
    width: 25px;
  }
  
  .drag-handle {
    font-size: 0.8rem;
  }
  
  .subsection-header-row {
    gap: 0.25rem;
    padding: 0 0.25rem;
  }
  
  .subsection-header-box {
    padding: 0.4rem 0.25rem;
    min-width: 120px;
  }
  
  .subsection-header-box h4 {
    font-size: 0.6rem;
  }
  
  .section-title-box h3 {
    font-size: 0.7rem;
  }
  
  .empty-box:first-of-type {
    width: 50px;
    height: 40px;
  }
  
  .empty-box:nth-of-type(2) {
    width: 50px;
    height: 40px;
  }
  
  .empty-box:nth-of-type(3) {
    width: 70px;
    height: 40px;
  }
  
  .empty-box:last-of-type {
    width: 35px;
    height: 40px;
  }
  
  .empty-box {
    font-size: 0.7rem;
  }
  
  .field-label {
    font-size: 0.75rem;
  }
}

/* Label del campo */
.field-label {
  font-weight: 400;
  color: #6c757d;
  font-size: 0.85rem;
  white-space: normal;
  text-align: center;
  line-height: 1.2;
}

/* Text boxes dentro de las cajas */
.text-box {
  background: transparent;
  border: none;
  outline: none;
  text-align: center;
  width: 100%;
  font-size: 0.8rem;
  color: #495057;
}

.text-box:focus {
  outline: none;
}

.text-box::placeholder {
  color: #6c757d;
  opacity: 0.7;
}

/* Responsive para mobile */
@media (max-width: 768px) {
  .text-box {
    font-size: 0.7rem;
  }
}

/* Botón de eliminar - Naranja como en la imagen */
.delete-btn {
  background: #f09502;
  border: none;
  color: white;
  padding: 0.25rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  font-size: 0.7rem;
}

.delete-btn:hover {
  background: #e08502;
  transform: scale(1.05);
}

/* Responsive para mobile */
@media (max-width: 768px) {
  .delete-btn {
    width: 24px;
    height: 24px;
    font-size: 0.6rem;
    padding: 0.2rem;
  }
}

/* Mensaje cuando no hay campos */
.no-fields-message {
  padding: 2rem;
  text-align: center;
  color: #6c757d;
  font-style: italic;
  background: #f8f9fa;
}

/* Mensaje cuando no hay secciones */
.no-sections-message {
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.empty-state {
  max-width: 400px;
  margin: 0 auto;
}

.empty-state i {
  font-size: 4rem;
  color: #dee2e6;
  margin-bottom: 1.5rem;
}

.empty-state h3 {
  color: #495057;
  margin: 0 0 1rem 0;
  font-weight: 600;
}

.empty-state p {
  color: #6c757d;
  margin: 0 0 2rem 0;
  line-height: 1.6;
}

.empty-state .btn {
  background: #f09502;
  border-color: #f09502;
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.empty-state .btn:hover {
  background: #e08502;
  border-color: #e08502;
  transform: translateY(-2px);
}

/* Animaciones para drag & drop */
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  background: white;
}

.cdk-drag-placeholder {
  opacity: 0.3;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  min-height: 60px;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drop-list-dragging .cdk-drag:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

/* Responsive */
@media (max-width: 768px) {
  .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .section-title {
    justify-content: space-between;
  }
  
  .section-columns {
    justify-content: center;
    margin-right: 0;
  }
  
  .field-item {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }
  
  .field-inputs {
    justify-content: center;
  }
  
  .field-input {
    min-width: 100%;
  }
}

/* Estilos para campos editables */
.editable-label {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  padding: 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  outline: none;
}

.editable-label:hover {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.editable-label:focus {
  background: white;
  border: 2px solid #f09502;
  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
}

.editable-label:focus::placeholder {
  color: #6c757d;
}

/* Mejoras para el botón de agregar */
.add-item-btn {
  background: #6c757d;
  border: 2px solid #6c757d;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.add-item-btn:hover {
  background: #f09502;
  border-color: #f09502;
  transform: scale(1.1);
}

.add-item-btn:active {
  transform: scale(0.95);
}

/* Mejoras para los inputs de valores */
.text-box {
  transition: all 0.2s ease;
}

.text-box:focus {
  border-color: #f09502;
  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.1);
}

.text-box:hover {
  border-color: #dee2e6;
}

/* Animación para nuevos campos */
.field-row {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para campos vacíos */
.editable-label:placeholder-shown {
  color: #6c757d;
  font-style: italic;
}

/* Mejoras para el drag handle */
.drag-handle {
  transition: all 0.2s ease;
}

.drag-handle:hover {
  color: #f09502;
  transform: scale(1.1);
}

/* Estilos para el botón de eliminar */
.delete-btn {
  transition: all 0.2s ease;
}

.delete-btn:hover {
  color: #dc3545;
  transform: scale(1.1);
}

/* Estilos para botones plus de subsecciones */
.add-subsection-btn {
  background: #6c757d;
  border: 2px solid #6c757d;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
}

.add-subsection-btn:hover {
  background: #f09502;
  border-color: #f09502;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.3);
}

.add-subsection-btn:active {
  transform: scale(0.95);
}


.empty-box {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 500;
}

.empty-box:last-child {
  width: 40px;
  justify-content: center;
}
/* Nuevos estilos tipográficos de la tabla financiera */
.editable-label,
.text-box,
.read-only-value,
.field-label {
  color: #000 !important;
  text-align: center !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

.total-row-container {
  background: transparent !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
}

.total-row-highlight {
  border-radius: 10px !important;
  background: #FFD288 !important;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  color: #000 !important;
}

.total-row-highlight .editable-label,
.total-row-highlight .text-box,
.total-row-highlight .read-only-value,
.total-row-highlight .field-label {
  font-weight: 700 !important;
}

/* ==========================================================================
   RESPONSIVE DESIGN (Top-Down Strategy: KISS & Clean Code)
   ========================================================================== */

/* --------------------------------------------------------------------------
   DESKTOP SMALL (max-width: 1280px)
   Objetivo: Reducir los anchos fijos de 764px para que quepan en la pantalla
   -------------------------------------------------------------------------- */
@media (max-width: 1280px) {
  .section-title-box,
  .subsection-header-box,
  .label-box {
    width: 600px !important; /* Reducido de 764px */
  }
}

/* --------------------------------------------------------------------------
   TABLET (max-width: 834px)
   Objetivo: Hacer las cajas más fluidas o colapsar
   -------------------------------------------------------------------------- */
@media (max-width: 834px) {
  .section-title-box,
  .subsection-header-box,
  .label-box {
    width: 350px !important; /* Ajustado para Tablet (aprox 50% de la pantalla) */
  }

  /* Reducimos fuentes para que quepan los textos en cajas más pequeñas */
  .section-title-box h3,
  .subsection-header-box h4 {
    font-size: 14px !important;
  }
  
  .objective-header-box,
  .sub-header-currency {
    font-size: 14px !important;
  }
}


.subtotal-highlight {
  background: white !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
}
.subtotal-highlight h4 {
  color: #000 !important;
}

.split-label-container { 
  display: flex !important; 
  align-items: center !important; 
  justify-content: center !important; 
  width: 100% !important; 
  gap: 8px !important;
}
.editable-label-text { 
  flex: 0 1 auto !important;
  width: auto !important;
  field-sizing: content !important;
  min-width: 100px !important;
  max-width: 100% !important;
  text-align: right !important; 
  padding: 0 !important; 
}
.label-pipe {
  flex: 0 0 auto !important; 
  margin: 0 2px !important; 
  color: #000 !important; 
  font-weight: 400 !important;
}
.editable-label-percentage { 
  flex: 0 1 auto !important;
  width: auto !important;
  field-sizing: content !important;
  min-width: 40px !important;
  max-width: 80px !important;
  text-align: center !important; 
  padding: 0 !important;
  margin-left: 0 !important;
  font-weight: 700 !important; 
  color: #000 !important;
}
.label-percent { 
  margin-left: 0 !important; 
  color: #000 !important; 
  font-weight: 700 !important; 
}

/* Typography required by user */
.editable-label,
.field-label,
.read-only-value,
.text-box,
.input-symbol {
  color: #000 !important;
  text-align: center !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

/* --------------------------------------------------------------------------
   MOBILE (max-width: 768px)
   Uniformar tamaño de fuente a 11px en todas las filas del resumen financiero
   -------------------------------------------------------------------------- */
@media (max-width: 768px) {
  .financial-module .editable-label,
  .financial-module .field-label,
  .financial-module .read-only-value,
  .financial-module .text-box,
  .financial-module .input-symbol,
  .financial-module .label-pipe,
  .financial-module .label-percent,
  .financial-module .editable-label-text,
  .financial-module .editable-label-percentage,
  .financial-module .section-title-box h3,
  .financial-module .subsection-header-box h4,
  .financial-module .objective-header-box,
  .financial-module .objective-header-box span,
  .financial-module .sub-header-currency,
  .financial-module .header-box {
    font-size: 11px !important;
  }
}

.input-with-symbol {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  position: relative;
  gap: 6px !important;
}

.input-with-symbol .text-box {
  flex: 0 1 auto !important;
  width: auto !important;
  field-sizing: content !important;
  min-width: 40px !important;
  max-width: 100% !important;
  text-align: center !important;
  padding: 0 !important;
}

.input-symbol {
  position: static !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-financial/new-project-financial.component.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB,EAAE,mCAAmC;EAC3D,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;;;EAGE,sBAAsB,EAAE,2BAA2B;EACnD,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;;EAEE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;AACxD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;;;AAIA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA,uDAAuD;AACvD;;;;EAIE,sBAAsB;EACtB,6BAA6B;EAC7B,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qDAAqD;EACrD,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;+EAE+E;;AAE/E;;;+EAG+E;AAC/E;EACE;;;IAGE,uBAAuB,EAAE,sBAAsB;EACjD;AACF;;AAEA;;;+EAG+E;AAC/E;EACE;;;IAGE,uBAAuB,EAAE,oDAAoD;EAC/E;;EAEA,uEAAuE;EACvE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;;AAGA;EACE,4BAA4B;EAC5B,qDAAqD;AACvD;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;;;;;EAKE,sBAAsB;EACtB,6BAA6B;EAC7B,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;;+EAG+E;AAC/E;EACE;;;;;;;;;;;;;;;IAeE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Estilos para el módulo financiero principal - Diseño exacto de la imagen */\n\n.financial-module {\n  background: white;\n  padding: 0;\n  margin-bottom: 2rem;\n}\n\n/* Contenedor de secciones */\n.sections-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Tarjeta de sección financiera */\n.financial-section-card {\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.financial-section-card:hover {\n  box-shadow: none;\n}\n\n/* Header de la sección - Naranja como en la imagen */\n.section-header {\n  background: #f09502;\n  color: white;\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px 12px 0 0;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n}\n\n.drag-handle {\n  cursor: grab;\n  color: rgba(255, 255, 255, 0.8);\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.drag-handle:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n.section-title h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: white;\n}\n\n/* Headers de columnas como cajas independientes */\n.column-headers {\n  display: flex;\n  gap: 10px;\n  padding: 0;\n  background: transparent;\n  border-bottom: none;\n  margin-bottom: 15px;\n}\n\n.header-box {\n  background: #F3F3F3 !important;\n  color: #000 !important;\n  height: 49px;\n  border-radius: 10px !important;\n  padding: 0 1rem;\n  font-weight: 600;\n  font-size: 0.8rem;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.header-box:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.section-title-box {\n  flex: 7 1 0 !important; /* 70% of available space roughly */\n  width: auto !important;\n  justify-content: center;\n}\n\n.section-title-box h3 {\n  color: #000 !important;\n  text-align: center !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 18px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.objective-header-box {\n  flex: 1 0 0 !important;\n  width: auto !important;\n  min-width: auto !important;\n  color: #000 !important;\n  text-align: center !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 18px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.add-button-box {\n  width: 40px;\n  padding: 0.25rem;\n}\n\n/* Responsive para mobile */\n@media (max-width: 768px) {\n  .column-headers {\n    gap: 0.25rem;\n    padding: 0.5rem;\n  }\n  \n  .header-box {\n    padding: 0.4rem 0.5rem;\n    font-size: 0.7rem;\n  }\n  \n  .section-title-box {\n    min-width: 120px;\n    gap: 0.25rem;\n  }\n  \n  .percentage-header-box {\n    width: 50px;\n  }\n  \n  .objective-header-box {\n    width: 70px;\n  }\n  \n  .add-button-box {\n    width: 35px;\n    padding: 0.2rem;\n  }\n}\n\n/* Botón de añadir */\n.add-item-btn {\n  background: #6c757d;\n  color: white;\n  border: 2px solid #6c757d;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 1rem;\n}\n\n.add-item-btn:hover {\n  background: #f09502;\n  border-color: #f09502;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.3);\n}\n\n/* Contenido de la sección */\n.section-content {\n  padding: 0;\n}\n\n/* Lista de campos */\n.fields-list {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Lista de subsecciones */\n.subsections-list {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Subsección individual */\n.subsection {\n  border-bottom: none;\n}\n\n/* Header de subsección como fila de cajas */\n.subsection-header-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  padding: 0;\n}\n\n.subsection-header-box {\n  background: #F3F3F3 !important;\n  color: #000;\n  border-radius: 10px !important;\n  padding: 0 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 7 1 0 !important;\n  width: auto !important;\n  box-shadow: none;\n  height: 49px;\n}\n\n.subsection-header-box h4 {\n  color: #000 !important;\n  text-align: center !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 18px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.empty-box {\n  background: #e9ecef;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #dee2e6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n/* Asegurar modelo de caja consistente */\n.header-box, .field-box, .empty-box {\n  box-sizing: border-box;\n}\n\n/* Anchos específicos uniformes */\n.objective-header-box, \n.sub-header-currency, \n.value-box {\n  flex: 3 1 0 !important; /* 30% of available space */\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: none !important;\n  gap: 6px !important;\n}\n\n.add-button-box, \n.sub-header-action, \n.delete-box {\n  width: 40px !important;\n  min-width: 40px !important;\n  max-width: 40px !important;\n}\n\n/* Ajuste específico para header de subsecciones */\n.sub-header-currency,\n.sub-header-action {\n  height: 49px;\n}\n\n/* Campos de la subsección */\n.subsection-fields {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Contenedor de drag & drop */\n.fields-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.fields-list.cdk-drop-list-dragging .field-row:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n/* Fila de campo individual */\n.field-row {\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n  margin-bottom: 10px;\n  cursor: grab;\n  padding: 0;\n  transition: all 0.2s ease;\n}\n\n.field-row:active {\n  cursor: grabbing;\n}\n\n.field-row.cdk-drag-preview {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  transform: rotate(2deg);\n}\n\n.field-row.cdk-drag-placeholder {\n  opacity: 0.4;\n}\n\n.field-row.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n/* Cajas independientes */\n.field-box {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  border: none;\n  padding: 12px 1rem;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.field-box:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.label-box, .subsection-header-box {\n  flex: 7 1 0 !important;\n  width: auto !important;\n  justify-content: center;\n}\n\n\n\n.delete-box {\n  width: 40px;\n  padding: 0.25rem;\n}\n\n/* Caja de drag handle */\n.drag-handle-box {\n  width: 30px;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.drag-handle {\n  color: #6c757d;\n  cursor: grab;\n  font-size: 1rem;\n  padding: 0.25rem;\n}\n\n.drag-handle:hover {\n  color: #495057;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n/* Responsive para mobile */\n@media (max-width: 768px) {\n  .field-row {\n    gap: 0.25rem;\n    padding: 0 0.25rem;\n  }\n  \n  .field-box {\n    padding: 0.4rem 0.25rem;\n  }\n  \n  .label-box {\n    min-width: 120px;\n    gap: 0.25rem;\n  }\n  \n  .percentage-box {\n    width: 50px;\n  }\n  \n  .value-box {\n    width: 70px;\n  }\n  \n  .delete-box {\n    width: 35px;\n    padding: 0.2rem;\n  }\n  \n  .drag-handle-box {\n    width: 25px;\n  }\n  \n  .drag-handle {\n    font-size: 0.8rem;\n  }\n  \n  .subsection-header-row {\n    gap: 0.25rem;\n    padding: 0 0.25rem;\n  }\n  \n  .subsection-header-box {\n    padding: 0.4rem 0.25rem;\n    min-width: 120px;\n  }\n  \n  .subsection-header-box h4 {\n    font-size: 0.6rem;\n  }\n  \n  .section-title-box h3 {\n    font-size: 0.7rem;\n  }\n  \n  .empty-box:first-of-type {\n    width: 50px;\n    height: 40px;\n  }\n  \n  .empty-box:nth-of-type(2) {\n    width: 50px;\n    height: 40px;\n  }\n  \n  .empty-box:nth-of-type(3) {\n    width: 70px;\n    height: 40px;\n  }\n  \n  .empty-box:last-of-type {\n    width: 35px;\n    height: 40px;\n  }\n  \n  .empty-box {\n    font-size: 0.7rem;\n  }\n  \n  .field-label {\n    font-size: 0.75rem;\n  }\n}\n\n/* Label del campo */\n.field-label {\n  font-weight: 400;\n  color: #6c757d;\n  font-size: 0.85rem;\n  white-space: normal;\n  text-align: center;\n  line-height: 1.2;\n}\n\n/* Text boxes dentro de las cajas */\n.text-box {\n  background: transparent;\n  border: none;\n  outline: none;\n  text-align: center;\n  width: 100%;\n  font-size: 0.8rem;\n  color: #495057;\n}\n\n.text-box:focus {\n  outline: none;\n}\n\n.text-box::placeholder {\n  color: #6c757d;\n  opacity: 0.7;\n}\n\n/* Responsive para mobile */\n@media (max-width: 768px) {\n  .text-box {\n    font-size: 0.7rem;\n  }\n}\n\n/* Botón de eliminar - Naranja como en la imagen */\n.delete-btn {\n  background: #f09502;\n  border: none;\n  color: white;\n  padding: 0.25rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  font-size: 0.7rem;\n}\n\n.delete-btn:hover {\n  background: #e08502;\n  transform: scale(1.05);\n}\n\n/* Responsive para mobile */\n@media (max-width: 768px) {\n  .delete-btn {\n    width: 24px;\n    height: 24px;\n    font-size: 0.6rem;\n    padding: 0.2rem;\n  }\n}\n\n/* Mensaje cuando no hay campos */\n.no-fields-message {\n  padding: 2rem;\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n  background: #f8f9fa;\n}\n\n/* Mensaje cuando no hay secciones */\n.no-sections-message {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.empty-state {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.empty-state i {\n  font-size: 4rem;\n  color: #dee2e6;\n  margin-bottom: 1.5rem;\n}\n\n.empty-state h3 {\n  color: #495057;\n  margin: 0 0 1rem 0;\n  font-weight: 600;\n}\n\n.empty-state p {\n  color: #6c757d;\n  margin: 0 0 2rem 0;\n  line-height: 1.6;\n}\n\n.empty-state .btn {\n  background: #f09502;\n  border-color: #f09502;\n  color: white;\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.empty-state .btn:hover {\n  background: #e08502;\n  border-color: #e08502;\n  transform: translateY(-2px);\n}\n\n/* Animaciones para drag & drop */\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  background: white;\n}\n\n.cdk-drag-placeholder {\n  opacity: 0.3;\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 12px;\n  min-height: 60px;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.cdk-drop-list-dragging .cdk-drag:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .section-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n  \n  .section-title {\n    justify-content: space-between;\n  }\n  \n  .section-columns {\n    justify-content: center;\n    margin-right: 0;\n  }\n  \n  .field-item {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n  }\n  \n  .field-inputs {\n    justify-content: center;\n  }\n  \n  .field-input {\n    min-width: 100%;\n  }\n}\n\n/* Estilos para campos editables */\n.editable-label {\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #333;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.editable-label:hover {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n}\n\n.editable-label:focus {\n  background: white;\n  border: 2px solid #f09502;\n  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n}\n\n.editable-label:focus::placeholder {\n  color: #6c757d;\n}\n\n/* Mejoras para el botón de agregar */\n.add-item-btn {\n  background: #6c757d;\n  border: 2px solid #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.add-item-btn:hover {\n  background: #f09502;\n  border-color: #f09502;\n  transform: scale(1.1);\n}\n\n.add-item-btn:active {\n  transform: scale(0.95);\n}\n\n/* Mejoras para los inputs de valores */\n.text-box {\n  transition: all 0.2s ease;\n}\n\n.text-box:focus {\n  border-color: #f09502;\n  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.1);\n}\n\n.text-box:hover {\n  border-color: #dee2e6;\n}\n\n/* Animación para nuevos campos */\n.field-row {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Estilos para campos vacíos */\n.editable-label:placeholder-shown {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Mejoras para el drag handle */\n.drag-handle {\n  transition: all 0.2s ease;\n}\n\n.drag-handle:hover {\n  color: #f09502;\n  transform: scale(1.1);\n}\n\n/* Estilos para el botón de eliminar */\n.delete-btn {\n  transition: all 0.2s ease;\n}\n\n.delete-btn:hover {\n  color: #dc3545;\n  transform: scale(1.1);\n}\n\n/* Estilos para botones plus de subsecciones */\n.add-subsection-btn {\n  background: #6c757d;\n  border: 2px solid #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n}\n\n.add-subsection-btn:hover {\n  background: #f09502;\n  border-color: #f09502;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(240, 149, 2, 0.3);\n}\n\n.add-subsection-btn:active {\n  transform: scale(0.95);\n}\n\n\n.empty-box {\n  width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.empty-box:last-child {\n  width: 40px;\n  justify-content: center;\n}\n/* Nuevos estilos tipográficos de la tabla financiera */\n.editable-label,\n.text-box,\n.read-only-value,\n.field-label {\n  color: #000 !important;\n  text-align: center !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n}\n\n.total-row-container {\n  background: transparent !important;\n  padding: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.total-row-highlight {\n  border-radius: 10px !important;\n  background: #FFD288 !important;\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12) !important;\n  border: none !important;\n  color: #000 !important;\n}\n\n.total-row-highlight .editable-label,\n.total-row-highlight .text-box,\n.total-row-highlight .read-only-value,\n.total-row-highlight .field-label {\n  font-weight: 700 !important;\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN (Top-Down Strategy: KISS & Clean Code)\n   ========================================================================== */\n\n/* --------------------------------------------------------------------------\n   DESKTOP SMALL (max-width: 1280px)\n   Objetivo: Reducir los anchos fijos de 764px para que quepan en la pantalla\n   -------------------------------------------------------------------------- */\n@media (max-width: 1280px) {\n  .section-title-box,\n  .subsection-header-box,\n  .label-box {\n    width: 600px !important; /* Reducido de 764px */\n  }\n}\n\n/* --------------------------------------------------------------------------\n   TABLET (max-width: 834px)\n   Objetivo: Hacer las cajas más fluidas o colapsar\n   -------------------------------------------------------------------------- */\n@media (max-width: 834px) {\n  .section-title-box,\n  .subsection-header-box,\n  .label-box {\n    width: 350px !important; /* Ajustado para Tablet (aprox 50% de la pantalla) */\n  }\n\n  /* Reducimos fuentes para que quepan los textos en cajas más pequeñas */\n  .section-title-box h3,\n  .subsection-header-box h4 {\n    font-size: 14px !important;\n  }\n  \n  .objective-header-box,\n  .sub-header-currency {\n    font-size: 14px !important;\n  }\n}\n\n\n.subtotal-highlight {\n  background: white !important;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;\n}\n.subtotal-highlight h4 {\n  color: #000 !important;\n}\n\n.split-label-container { \n  display: flex !important; \n  align-items: center !important; \n  justify-content: center !important; \n  width: 100% !important; \n  gap: 8px !important;\n}\n.editable-label-text { \n  flex: 0 1 auto !important;\n  width: auto !important;\n  field-sizing: content !important;\n  min-width: 100px !important;\n  max-width: 100% !important;\n  text-align: right !important; \n  padding: 0 !important; \n}\n.label-pipe {\n  flex: 0 0 auto !important; \n  margin: 0 2px !important; \n  color: #000 !important; \n  font-weight: 400 !important;\n}\n.editable-label-percentage { \n  flex: 0 1 auto !important;\n  width: auto !important;\n  field-sizing: content !important;\n  min-width: 40px !important;\n  max-width: 80px !important;\n  text-align: center !important; \n  padding: 0 !important;\n  margin-left: 0 !important;\n  font-weight: 700 !important; \n  color: #000 !important;\n}\n.label-percent { \n  margin-left: 0 !important; \n  color: #000 !important; \n  font-weight: 700 !important; \n}\n\n/* Typography required by user */\n.editable-label,\n.field-label,\n.read-only-value,\n.text-box,\n.input-symbol {\n  color: #000 !important;\n  text-align: center !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 20px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n}\n\n/* --------------------------------------------------------------------------\n   MOBILE (max-width: 768px)\n   Uniformar tamaño de fuente a 11px en todas las filas del resumen financiero\n   -------------------------------------------------------------------------- */\n@media (max-width: 768px) {\n  .financial-module .editable-label,\n  .financial-module .field-label,\n  .financial-module .read-only-value,\n  .financial-module .text-box,\n  .financial-module .input-symbol,\n  .financial-module .label-pipe,\n  .financial-module .label-percent,\n  .financial-module .editable-label-text,\n  .financial-module .editable-label-percentage,\n  .financial-module .section-title-box h3,\n  .financial-module .subsection-header-box h4,\n  .financial-module .objective-header-box,\n  .financial-module .objective-header-box span,\n  .financial-module .sub-header-currency,\n  .financial-module .header-box {\n    font-size: 11px !important;\n  }\n}\n\n.input-with-symbol {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n  gap: 6px !important;\n}\n\n.input-with-symbol .text-box {\n  flex: 0 1 auto !important;\n  width: auto !important;\n  field-sizing: content !important;\n  min-width: 40px !important;\n  max-width: 100% !important;\n  text-align: center !important;\n  padding: 0 !important;\n}\n\n.input-symbol {\n  position: static !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
